import script from "./Manuals.vue?vue&type=script&lang=ts&setup=true"
export * from "./Manuals.vue?vue&type=script&lang=ts&setup=true"

import "./Manuals.vue?vue&type=style&index=0&id=b969f626&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b969f626"]])

export default __exports__